import { render, staticRenderFns } from "./ai-check.vue?vue&type=template&id=66bfd2ec"
import script from "./ai-check.vue?vue&type=script&lang=js"
export * from "./ai-check.vue?vue&type=script&lang=js"
import style0 from "./ai-check.vue?vue&type=style&index=0&id=66bfd2ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports